import { FormikProps } from "formik";
import { PayoutAccountPayload } from "../../redux/features/payment/payment.types";
import { Icon } from "../icon/icon";
import { TextInput } from "../inputs/textInput";

export const ConfirmCADPayoutForm = ({
  formik,
  isModalDisplay,
}: {
  formik: FormikProps<PayoutAccountPayload & { confirm: string }>;
  isModalDisplay?: boolean;
}) => {
  return (
    <>
      {isModalDisplay ? (
        <Icon
          svg={"shield-question"}
          width={42}
          height={42}
          className="rounded-xl border border-grey-100 p-[11px] text-primary"
        />
      ) : undefined}

      <div>
        <p className="text-lg font-bold md:text-base">
          Confirm your Interac Email
        </p>
        <p className="text-sm text-grey-500">
          Please confirm your email before adding it as your payout account.
        </p>
      </div>

      <div className="flex items-start gap-4 rounded-2xl border border-grey-100 p-4">
        <img
          src="/assets/images/interac-logo.png"
          className="block aspect-square !size-[32px] min-w-[32px]"
          alt="interac"
        />

        <p className="flex flex-col text-sm">
          <span className="text-grey-500">Interac email</span>
          <span className="font-bold">{formik.values.interacEmail}</span>
        </p>
      </div>
    </>
  );
};

export const CADPayoutForm = ({
  formik,
}: {
  formik: FormikProps<PayoutAccountPayload & { confirm: string }>;
}) => {
  const { values, touched, handleBlur, handleChange, errors } = formik;

  return (
    <>
      <TextInput
        type="text"
        name="interacName"
        value={values.interacName}
        placeholder="Enter a name for your account"
        onChange={handleChange}
        onBlur={handleBlur}
        hasTitle
        title="Name"
        errors={
          errors.interacName && touched.interacName
            ? errors.interacName
            : undefined
        }
        customIconPosition="right"
        customIcon={undefined}
      />

      <TextInput
        type="text"
        name="interacEmail"
        value={values.interacEmail}
        placeholder="Enter your interac email address"
        onChange={handleChange}
        onBlur={handleBlur}
        hasTitle
        title="Interac Email Address"
        errors={
          errors.interacEmail && touched.interacEmail
            ? errors.interacEmail
            : undefined
        }
        customIconPosition="right"
        customIcon={undefined}
      />
    </>
  );
};
